// import { gql } from '@apollo/client';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloCache } from '@apollo/client/cache';
import { Resolvers } from '@apollo/client';
import { authMutations, authQueries, authQueryStrings } from './auth';
import { invitationQueryStrings, invitationMutations } from './invitations';
import { proQueries, proMutations, proQueryStrings } from './pro';
import { s3Mutations, s3Queries, s3QueryStrings } from './s3';
import {
    trqkDirectoryFields,
    trqkDirectoryQueryStrings,
    trqkDirectoryMutations,
    trqkDirectoryQueries,
} from './trqkDirectory';
import { taskMutations, taskQueryStrings } from './tasks';
import { uiStateQueryStrings } from './uiState';
import { typePolicies } from './typePolicies';
import {
    fieldPolicies,
    queryStrings as fieldPolicyQueryStrings,
} from './fieldPolicies';
import * as constants from './constants';
import * as utils from './utils';
import { initialStates } from './initialStates';
import { typeDefs } from './typeDefs';

type ResolverFn = (
    parent: any,
    args: any,
    { cache }: { cache: ApolloCache<any> },
) => any;

interface ResolverMap {
    [field: string]: ResolverFn;
}

interface AppResolvers extends Resolvers {
    Mutation: ResolverMap;
}

export const resolvers: AppResolvers = {
    Mutation: {
        ...authMutations,
        ...invitationMutations,
        ...proMutations,
        ...s3Mutations,
        ...taskMutations,
        ...trqkDirectoryMutations,
    },
    Query: {
        ...authQueries,
        ...proQueries,
        ...s3Queries,
        ...trqkDirectoryQueries,
    },
    ProDirectedTreeNodeEntity: {
        composer: (): string => 'composer',
        publisher: (): string => 'publisher',
        subpublisher: (): string => 'subpublisher',
        track: (): string => 'track',
        unknown: (): string => 'unknown',
    },
    PRORoleType: {
        publisher: (): string => 'publisher',
        writer: (): string => 'writer',
    },
};

export const queryStrings = {
    ...authQueryStrings,
    ...invitationQueryStrings,
    ...proQueryStrings,
    ...s3QueryStrings,
    ...trqkDirectoryQueryStrings,
    ...taskQueryStrings,
    ...uiStateQueryStrings,
    ...fieldPolicyQueryStrings,
};

const fields = {
    ...trqkDirectoryFields,
};

export {
    constants,
    fields,
    fieldPolicies,
    initialStates,
    typeDefs,
    typePolicies,
    s3Queries,
    utils,
};
